import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash-es';
import Container from 'reactstrap/lib/Container';
import { CalculatorMap } from 'client/tracking/maps/calculator';
import { AppraisalMap } from 'client/tracking/maps/appraisal';
import { PriceCheckerMap } from 'client/tracking/maps/core-page/price-checker/price-checker';
import { TrackingHandler } from 'client/tracking/handler';
import { getQuery } from 'client/utils/location';
import { getParamsForSharedDeal } from 'client/site-modules/price-checker/utils/url-share-deals';
import { PriceChecker } from 'site-modules/price-checker/components/price-checker/price-checker';
import { getLeadFormCreativeId } from 'site-modules/shared/components/lead-form/utils/lead-form-creative-id';
import { LEAD_FORMS_CREATIVE_ID } from 'site-modules/shared/components/lead-form/unified-lead-form/constants/creative-ids';
import { EngagementHandler } from 'client/engagement-handlers';
import { PriceCheckerEngagementHandler } from 'client/engagement-handlers/price-checker-engagement-handler/price-checker-engagement-handler';

import './price-checker-page.scss';

EngagementHandler.register(PriceCheckerEngagementHandler);

function PriceCheckerPageUI({
  params,
  location = null,
  visitorId = null,
  pageName = null,
  isMobile = false,
  sessionId = null,
}) {
  useEffect(() => {
    TrackingHandler.useMap({ ...AppraisalMap, ...CalculatorMap, ...PriceCheckerMap });
  }, []);

  const query = getQuery(location);
  const { make, model, year } = { ...params, ...query };
  const sharedDeal = getParamsForSharedDeal(query);
  const initialPrices = {
    userDealerPrice: query.dealerprice && parseInt(query.dealerprice, 10),
    userMsrp: query.msrp && parseInt(query.msrp, 10),
  };
  const leadFormCreativeId = getLeadFormCreativeId({
    isNewVin: true,
    pageNameLegacy: pageName,
    formName: LEAD_FORMS_CREATIVE_ID.PRICE_CHECKER_PAGE_FORM,
  });
  const isTestDeal = get(query, 'csd_api_test_submit', false); // was added to submit deal to the /api/car-buying/v1/crowd-sourced-deals API as a test record

  return (
    <Container tag="main" id="main-content" tabIndex={-1} className="price-checker-page py-3_5 px-md-0 px-lg-0_5">
      <PriceChecker
        make={make}
        model={model}
        year={year}
        styleId={query.styleId}
        vin={query.vin}
        initialPrices={initialPrices}
        isMobile={isMobile}
        leadFormCreativeId={leadFormCreativeId}
        sharedDeal={sharedDeal}
        visitorId={visitorId}
        isTestDeal={Boolean(isTestDeal)}
        pageName={pageName}
        sessionId={sessionId}
      />
    </Container>
  );
}

PriceCheckerPageUI.propTypes = {
  params: PropTypes.shape({
    make: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
    query: PropTypes.objectOf(PropTypes.string),
  }),
  visitorId: PropTypes.string,
  pageName: PropTypes.string,
  isMobile: PropTypes.bool,
  sessionId: PropTypes.string,
};

const mapStateToProps = state => ({
  isMobile: state.mobile,
  location: get(state, 'pageContext.location'),
  visitorId: get(state, 'visitor.id'),
  sessionId: get(state, 'visitor.session'),
  pageName: get(state, 'pageContext.legacy.pageName') || get(state, 'pageContext.page.name'),
});

export const PriceCheckerPage = connect(mapStateToProps)(PriceCheckerPageUI);
